export enum GroupType {
  group = "group",
  parentGroup = "parentGroup",
}

export interface LooseObject {
  [key: string]: any;
}
